/* jshint esversion: 6 */

import GtmService from '../gtm/gtm.service';

export default class GtmDirective {

	constructor() {
		this.restrict = 'A';

		this.scope = {
			eventname: "@?gtmEventname",
			searchterm: "@?gtmSearchterm",
			position: "@?gtmPosition",
			label: "@?gtmLabel",
			sottomenu: "@?gtmSottomenu",
			nomecontenuto: "@?gtmNomecontenuto",
			pagetype: "@?gtmPagetype",
			pagecategory: "@?gtmPagecategory",
			language: "@?gtmLanguage",
			firstlevelcategory: "@?gtmFirstlevelcategory",
			secondlevelcategory: "@?gtmSecondlevelcategory",
			thirdlevelcategory: "@?gtmThirdlevelcategory"
		};
	}

	link(scope, element, attributes, controller) {
		const node = element[0];

		const onClick = (event) => {
			var gtmObj = {
				event: "GA4event",
				eventname: "",
				searchterm: "",
				position: "",
				label: "",
				sottomenu: "",
				nomecontenuto: "",
				pagetype: "",
				pagecategory: "",
				language: "",
				firstlevelcategory: "",
				secondlevelcategory: "",
				thirdlevelcategory: ""
			};

			for (var key in gtmObj)
				if (scope[key])
					gtmObj[key] = scope[key];

			GtmService.push(gtmObj);
			console.log('GtmService.dataLayer2 ', dataLayer);
		}

		node.addEventListener('click', onClick);

		scope.$on('$destroy', () => {
			node.removeEventListener('click', onClick);
		});
	}

	static factory() {
		return new GtmDirective();
	}
}
